import { render, staticRenderFns } from "./tabMaterials.vue?vue&type=template&id=6bbf233e&"
import script from "./tabMaterials.vue?vue&type=script&lang=js&"
export * from "./tabMaterials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports